<div [ngClass]="{'mobile': isMobile}">
  <div class="subtitle">
    <typography variant="mat-subtitle-2" weight="bold">{{ appStrings.paymentDetails_ContactInfo }}</typography>
  </div>

  <div class="contact-info">
    <form *appIsMobile [formGroup]="contactDetailsForm" id="contactDetailsContainer">
      <ds-paper class="full-width-paper dark-paper" elevation="elevation_none"
        borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_S"
        insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
        @if (displayContactsList.length) {
          <ds-autocomplete id="contact" class="fill-width" [options]="displayContactsList" [label]="appStrings.paymentDetails_contact" drop_icon="search"
            label_orientation="vertical-label" [control]="contactDetailsForm.controls.contact" [isDisabled]="!canEdit || quoteSaveInProgress"
            (inputValueChange)="onContactSearchChange($event)" (selectionChange)="setContactFieldMobile($event.option.value)">
          </ds-autocomplete>
        }
        <ds-textfield id="contactName" class="fill-width" [label]="appStrings.paymentDetails_contact_name" label_orientation="vertical-label"
          [control]="contactDetailsForm.controls.contactName" [isDisabled]="!canEdit || quoteSaveInProgress" [maxLength]="fieldMaxLengths.contactName">
        </ds-textfield>
        <ds-textfield id="phoneNumber" class="fill-width" [label]="appStrings.paymentDetails_contact_phone" label_orientation="vertical-label"
          [control]="contactDetailsForm.controls.phoneNumber" [isDisabled]="!canEdit || quoteSaveInProgress" [maxLength]="fieldMaxLengths.phoneNumber">
        </ds-textfield>
        <ds-textfield id="email" class="fill-width" [label]="appStrings.paymentDetails_contact_email" label_orientation="vertical-label"
          [control]="contactDetailsForm.controls.email" [isDisabled]="!canEdit || quoteSaveInProgress" (onBlur)="contactEmailChange($event.target.value, true)"
          [maxLength]="fieldMaxLengths.email">
        </ds-textfield>
      </ds-paper>
    </form>

    <div *appIsDesktop>
      <form [formGroup]="contactDetailsForm" id="contactDetailsContainer">
        <div class="input-container">
          @if (displayContactsList.length) {
            <ds-autocomplete class="quarter-width fill-width fill-gap" id="contact" [options]="displayContactsList"
              [label]="appStrings.paymentDetails_contact" drop_icon="search" label_orientation="vertical-label" [control]="contactDetailsForm.controls.contact"
              [isDisabled]="!canEdit || quoteSaveInProgress" (inputValueChange)="onContactSearchChange($event)"
              (selectionChange)="setContactFieldMobile($event.option.value)">
            </ds-autocomplete>
          }
          <ds-textfield id="contactName" class="quarter-width fill-width fill-gap" [label]="appStrings.paymentDetails_contact_name" label_orientation="vertical-label"
            [control]="contactDetailsForm.controls.contactName" [isDisabled]="!canEdit || quoteSaveInProgress" [maxLength]="fieldMaxLengths.contactName">
          </ds-textfield>
          <ds-textfield id="phoneNumber" class="quarter-width fill-width fill-gap" [label]="appStrings.paymentDetails_contact_phone" label_orientation="vertical-label"
            [control]="contactDetailsForm.controls.phoneNumber" [isDisabled]="!canEdit || quoteSaveInProgress" [maxLength]="fieldMaxLengths.phoneNumber">
          </ds-textfield>
          <ds-textfield id="email" class="quarter-width fill-width fill-gap" [label]="appStrings.paymentDetails_contact_email" label_orientation="vertical-label"
            [control]="contactDetailsForm.controls.email" [isDisabled]="!canEdit || quoteSaveInProgress" (onBlur)="contactEmailChange($event.target.value, true)" [maxLength]="fieldMaxLengths.email">
          </ds-textfield>
        </div>
        <div class="button-container">
          <ds-button size="medium" type="tertiary" variant="label-icon" [label]="appStrings.paymentDetails_create_contact" id="addContactBtn" icon="add"
            (onClick)="openCreateContactDialog()" [isDisabled]="quoteSaveInProgress || !canEdit">
          </ds-button>
        </div>
      </form>
    </div>
  </div>

  @if (!isLead) {
    <ds-divider></ds-divider>
    <div [formGroup]="notificationsForm" [ngClass]="{'mobile': isMobile}">
      <div class="subtitle">
        <typography variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_ens_subtitle }}</typography>
      </div>
      <div formArrayName="notifications">
        @if (notifications.length === 0) {
          <div class="no-notification">
            <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
              <div class="info-container">
                <ds-icon icon="error" iconStyle="material-icons"></ds-icon>
                <typography variant="mat-body-2" weight="regular">{{appStrings.quote_ens_addRecipientMessage}}</typography>
              </div>
            </ds-paper>
          </div>
        }
        @if (notifications.length && showAmEmailMessage && !quoteCompleted) {
          <div>
            <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
              <div id="noEmailContainer" class="info-container">
                <ds-icon id="noEmailIcon" icon="info" iconStyle="material-icons"></ds-icon>
                <typography id="noEmailMessage" variant="mat-body-2" weight="regular">{{appStrings.quote_ens_noEmailMessage}}</typography>
              </div>
            </ds-paper>
          </div>
        }
        @if (!quoteCompleted && notifications.length > 0) {
          <div class="button-container">
            @if (isMobile && !quoteCompleted) {
              <ds-button size="medium" type="tertiary" variant="label-icon" icon="close" [label]="appStrings.quote_ens_clearAll"
                iconPosition="left" iconStyle="material-icons" (onClick)="clearAll()" id="clearAllButton">
              </ds-button>
            }
          </div>
        }
        @for (notificationRow of notifications.controls; track notificationRow; let i = $index) {
          <div class="notification-item" [formGroupName]="i">
            <ds-paper class="dark-paper" elevation="elevation_none" borderRadius="radius_XS" outline="outlined" [insidePaddingTop]="isMobile? 'top-spacing_S' : 'top-spacing_M'"
              [insidePaddingBottom]="isMobile ? 'bottom-spacing_S' : 'bottom-spacing_XS'">
              <div class="form-container" [id]="'emailNotificationRow_' + i">
                <ds-textfield class="fill-width" [ngClass]="{'third-width': !isMobile}" [label]="appStrings.contacts_email" label_orientation="vertical-label"
                  [control]="notificationRow.controls.email" [id]="'email_' + i" [isDisabled]="quoteCompleted" maxLength="100">
                </ds-textfield>
                <ds-select class="fill-width" [label]="appStrings.quote_ens_recipient" label_orientation="vertical-label" [control]="notificationRow.controls.recipientTypeId"
                  [id]="'recipientTypeId_' + i" [dropOptions]="recipientTypes" [isDisabled]="quoteCompleted">
                </ds-select>
                <ds-autocomplete-chips class="fill-width" [ngClass]="{'third-width fill-gap': !isMobile}" [label]="appStrings.quote_ens_attributes" label_orientation="vertical-label"
                  [options]="attributesList" [control]="notificationRow.controls.attributes" [id]="'attributes_' + i" [isDisabled]="quoteCompleted">
                </ds-autocomplete-chips>
                @if (!quoteCompleted) {
                  <ds-button class="delete-button" size="medium" type="tertiary" [variant]="isMobile ? 'label-icon' : 'icon-only'" icon="delete" [label]="appStrings.button_delete" iconPosition="left"
                    iconStyle="material-icons-outlined" (onClick)="deleteRow(i)" id="deleteButton" [isDisabled]="!showAmEmailMessage && (i === 0 && notifications.length > 1)">
                  </ds-button>
                }
              </div>
            </ds-paper>
          </div>
        }
        <div class="button-container two-buttons">
          @if (!isMobile && !quoteCompleted) {
            <ds-button size="medium" type="tertiary" variant="label-icon" icon="clearAllButton" [label]="appStrings.quote_ens_clearAll"
              iconPosition="left" iconStyle="material-icons" (onClick)="clearAll()" id="clearAllButton">
            </ds-button>
          }
          @if (!quoteCompleted) {
            <ds-button size="medium" type="tertiary" variant="label-icon" icon="addRecipientButton" [label]="appStrings.quote_ens_addRecipient"
              iconPosition="left" iconStyle="material-icons" (onClick)="addRow()" id="addNewNotification" [isDisabled]="notifications.length >= maxNotifications">
            </ds-button>
          }
          <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" (onClick)="goToPaymentDetails.emit()" id="continueBtn">
          </ds-button>
        </div>
      </div>
    </div>
  }
</div>